import { serial as polyfill, SerialPort as SerialPortPolyfill } from 'web-serial-polyfill';
import { EventEmitter } from 'events';
import USBToast from '../../components/toast/usb';

let port: SerialPort | SerialPortPolyfill | undefined;
let reader: ReadableStreamDefaultReader | ReadableStreamBYOBReader | undefined;
const usePolyfill = false;  // This can be changed if you want to use the polyfill
const bufferSize = 8 * 1024; // 8kB

const encoder = new TextEncoder();
//const decoder = new TextDecoder();
const decoder = new TextDecoder('latin1'); 
export const responseEmitter = new EventEmitter();

let keepListening = true;
let isClosing = false;
let isPortOpen = false;
let isResetting = false;
let isListening = false;
let listenerExitPromise: Promise<void> | null = null;
let resolveListenerExit: (() => void) | null = null;
let connectPromise: Promise<boolean> | null = null;
let lineBuffer = '';
let lastCheckPMConnection = Date.now();
let pmBusy = false;
export async function sendCommand(command: string) {
	console.log("sendCommand");
	if (!port?.writable) {
		console.warn(`Unable to find writable port`);
		return;
	}

	let encodedCommand = encoder.encode(command);
	let extendedCommand = new Uint8Array(encodedCommand.length + 1);
	extendedCommand.set(encodedCommand);
	extendedCommand[encodedCommand.length] = 13;

	const writer = port.writable.getWriter();
	console.log("command", extendedCommand);
	await writer.write(extendedCommand);
	writer.releaseLock();
}

export async function sendAnalyzerCommand(command: string) {
	console.log("analyzer command start");
	if (!port?.writable) {
		console.warn(`Unable to find writable port`);
		return;
	}

	let encodedCommand = encoder.encode(command);

	const writer = port.writable.getWriter();
	await writer.write(encodedCommand);
	writer.releaseLock();

}

export async function connectToPort(): Promise<boolean> {
	if (isPortOpen) {
		console.warn("Port is already open");
		return true;
	}

	connectPromise = (async () => {
		try {
			responseEmitter.on('error', async (msg) => {
				console.error('USBConnector error:', msg);
				await resetConnection();
			});
				const serial = 'serial' in navigator ? navigator.serial : polyfill;
			port = await serial.requestPort();
			
			if (port.readable || port.writable) // needed to re-connect to the port after a disconnect event
				await port.close();
			const pbmOptions = {
				baudRate: 38400,
				baudrate: 38400,
				dataBits: 8,
				databits: 8,
				flowControl: <const>"none",
				parity: <const>"none",
				rtscts: false,
				stopBits: 1,
				stopbits: 1
			};

			const analyzerOptions = {
				baudRate: 921600,
				baudrate: 921600,
				dataBits: 8,
				databits: 8,
				flowControl: <const>"none",
				parity: <const>"none",
				rtscts: false,
				stopBits: 1,
				stopbits: 1
			};

			await port.open(analyzerOptions as any);

			isPortOpen = true;
			console.log('Connected to selected port.');
			responseEmitter.emit('connection', true);

			keepListening = true;

			//Check for analyzer first, then if that fails assume PBM
			// Start the listener only when we just opened the port
			if (!isListening) listenToPort();

			return true;
		} catch (e) {
			console.error('Failed to connect:', e);
			await resetConnection();
			return false;
		} finally {
			connectPromise = null;
		}
	})();

	return connectPromise;
}

async function listenToPort() {
	if (isListening) return; // already listening
	isListening = true;
	listenerExitPromise = new Promise(resolve => {
		resolveListenerExit = resolve;
	});
	try {
		while (port?.readable && keepListening && !isClosing) {
		try {
			reader = port.readable.getReader({ mode: 'byob' });
			console.log("reader-byob", reader);

			while (keepListening && !isClosing) {
				const { value, done } = await reader.read(new Uint8Array(bufferSize));
				if (done) {
					console.log('Stream ended.');
					break;
				}
				if (value) {
					const text = decoder.decode(value, { stream: true });
					if (
						text.trim().startsWith('05NBF5') ||
						text.trim().startsWith('5NBF5') ||
						text.trim().startsWith('05O1E5') ||
						text.trim().startsWith('5O1E5') ||
						text.trim().startsWith('05O2E6') ||
						text.trim().startsWith('5O2E6') ||
						text.trim().startsWith('O2E6') ||
						text.trim().startsWith('1AP') || 
						text.trim().startsWith('AP') ||
						text.trim().startsWith('05OEF9') || // Door Opened
						text.trim().startsWith('5OEF9') ||  // Door Opened(first char missing)
						text.trim().startsWith('OEF9') || // Door Opened(first 2 chars missing)
						text.trim().startsWith('05NIFC') || // Rare case where door opened
						text.trim().startsWith('5NIFC') || // Rare case where door opened(missing first char)
						text.trim().startsWith('NIFC') || // Rare case where door opened(missing first 2 chars)
						text.trim().startsWith('05O3E7') || // Device is physically connected, and Door Opened
						text.trim().startsWith('5O3E7') ||  // Device is physically connected, and Door Opened(first char missing)
						text.trim().match(/PM\d{5}-\d{2}/) // getPMStatus S/N pattern: PM<5 digits>-<2 digits>... (e.g., PM12345-01)
					) {
						responseEmitter.emit('data', text.trim());
						continue;
					} 
					if (text.trim().startsWith('05NKFE') || text.trim().startsWith('5NKFE')) { // PM is not connected
						lineBuffer = '';
						keepListening = false;
						isPortOpen = false;
						responseEmitter.emit('connection', false);
						responseEmitter.emit('error', 'Device disconnected');
						USBToast('Connection error', 'PhotonMaster not detected. Please ensure the PhotonMaster is properly connected to the Bluetooth Module, then try again.', 'pm-module-usb-connection-error');
						continue;
					}
					if (text.trim().startsWith('08B')) { // get PBM ID
						responseEmitter.emit('PBMID', text.trim());
						continue;
					}

					lineBuffer += text;
					// Process complete lines
					const lines = lineBuffer.split('\n');
					for (let i = 0; i < lines.length - 1; i++) {
						const line = lines[i].replaceAll('\r', '').trim();
						if (line) {
							console.log("Received:", line);
							responseEmitter.emit('data', line);
						}
					}
					// Keep incomplete line in buffer
					lineBuffer = lines[lines.length - 1];
				}
			}
		} catch (e) {
			const isDisconnected = e instanceof Error && (
					e.message.includes('device has been lost') ||
					e.message.includes('NetworkError') ||
					e.name === 'NetworkError'
			);
			if (isDisconnected) {
				lineBuffer = '';
				keepListening = false;
				isPortOpen = false;
				responseEmitter.emit('connection', false);
				responseEmitter.emit('error', 'Device disconnected');
				break;
			}
			console.error(e);
		} finally {
			if (reader) {
				reader.releaseLock();
				if (keepListening) port = undefined;
				reader = undefined;
			}
		}
	}
	} finally {
		isListening = false;
		// Flush any remaining data in the buffer
		if (lineBuffer.trim() && keepListening) {
			responseEmitter.emit('data', lineBuffer);
		}
		lineBuffer = '';
		resolveListenerExit?.();
		resolveListenerExit = null;
		listenerExitPromise = null;
	}
}

export async function resetConnection() {
	console.log("Resetting connection...");
	if (isResetting || isClosing) {
		console.log('resetConnection: another operation is in progress, skipping');
		return;
	}
	isResetting = true;
	keepListening = false;

	if (port && isPortOpen) {
		console.log("trying to close");
		try {
			try {
				reader?.releaseLock();
			} catch (error) { console.log("failed to release reader lock", error); }

			try {
				let writer = port?.writable?.getWriter();
				writer?.releaseLock();
			} catch (error) { console.log("failed to release writer lock", error); }

			try {
				await port?.close();
				console.log("Port closed");
			} catch (error) { console.log("failed to close port", error); }

			console.log("port closed");
			isPortOpen = false;
			
		} catch (e) {
			console.error('Error closing port:', e);
		}
	}
	
	isResetting = false;
}

export async function disconnectFromPort(): Promise<void> {

	if (isClosing) return;
	keepListening = false;
	isClosing = true;

	try {
		reader?.releaseLock();
	} catch (error) { console.log("failed to release reader lock", error); }

	try {
		let writer = port?.writable?.getWriter();
		writer?.releaseLock();
	} catch (error) { console.log("failed to release writer lock", error); }

	try {
		await port?.close();
		console.log("Port closed");
	} catch (error) { console.log("failed to close port", error); }

	responseEmitter.emit('connection', false);
	port = undefined;
	reader = undefined;
	isClosing = false;
	isPortOpen = false;

}

/**
 * Pause the listenToPort loop and release the reader lock.
 */
export async function pauseListening() {
	keepListening = false;
	if (reader) {
		try {
			await reader.cancel();
		} catch {}
	}
	await listenerExitPromise;
}

/**
 * Resume listening to the port after a pause.
 */
export async function resumeListening() {
	keepListening = true;
	if (!isListening && port?.readable) {
		listenToPort();
	}
}

export function setPMBusy(busy: boolean) {
    pmBusy = busy;
}

export function getPMBusy(): boolean {
    return pmBusy;
}
/**
 * Requests information about the PM, responds with '05NKFE' if it's not connected.
 * Only executes once every 4 seconds to prevent spamming PM with requests causing unresponsiveness.
 */

export async function checkPMConnection(): Promise<void> {
    if (pmBusy){
		return;
	}
	setPMBusy(true);
	await new Promise(resolve => setTimeout(resolve, 200));
    const now = Date.now();
    if (now - lastCheckPMConnection < 1000) return;
    lastCheckPMConnection = now;
    await getPMandPBMDeviceInfo();
	setPMBusy(false);
};

export async function getPMandPBMDeviceInfo(): Promise<void> {
	await sendCommand("04DA8");
	await new Promise(resolve => setTimeout(resolve, 250));
	await sendCommand("04BA6");
	await new Promise(resolve => setTimeout(resolve, 150));
}

/**
 * Send a file using the XMODEM protocol over the current serial port.
 * @param file Uint8Array or File (browser) to send
 * @param onProgress Optional callback for progress reporting (0-100)
 * @returns Promise<void>
 */
export async function sendXMODEM(file: File | Uint8Array, onProgress?: (percent: number) => void): Promise<void> {
	if (!port?.writable || !port?.readable) throw new Error('Serial port not open');
	await pauseListening();
	let data: Uint8Array;
	if (file instanceof Uint8Array) {
		data = file;
	} else {
		data = new Uint8Array(await file.arrayBuffer());
	}
	const writer = port.writable.getWriter();
	const reader = port.readable.getReader();

	//XMODEM constants
	const SOH = 0x01, EOT = 0x04, ACK = 0x06, NAK = 0x15, CAN = 0x18, CPMEOF = 0x1A, CRC = 0x43; // 'C'
	const BLOCK_SIZE = 128;
	const MAX_RETRIES = 10;
	let blockNum = 1;
	let offset = 0;
	let totalBlocks = Math.ceil(data.length / BLOCK_SIZE);
	let aborted = false;
	let useCRC = false;

	function crc16(buf: Uint8Array) {
		let crc = 0;
		for (let i = 0; i < buf.length; i++) {
			crc ^= (buf[i] << 8);
			for (let j = 0; j < 8; j++) {
				if (crc & 0x8000) crc = (crc << 1) ^ 0x1021;
				else crc <<= 1;
			}
			crc &= 0xFFFF;
		}
		return crc;
	}

	// Helper: build a block (CRC or checksum)
	function buildBlock(blockNum: number, chunk: Uint8Array, useCRC: boolean): Uint8Array {
		const block = new Uint8Array(3 + BLOCK_SIZE + (useCRC ? 2 : 1));
		block[0] = SOH;
		block[1] = blockNum & 0xFF;
		block[2] = 0xFF - (blockNum & 0xFF);
		for (let i = 0; i < BLOCK_SIZE; i++) {
			block[3 + i] = i < chunk.length ? chunk[i] : CPMEOF;
		}
		if (useCRC) {
			const crc = crc16(block.slice(3, 3 + BLOCK_SIZE));
			block[3 + BLOCK_SIZE] = (crc >> 8) & 0xFF;
			block[3 + BLOCK_SIZE + 1] = crc & 0xFF;
		} else {
			let sum = 0;
			for (let i = 0; i < BLOCK_SIZE; i++) sum = (sum + block[3 + i]) & 0xFF;
			block[3 + BLOCK_SIZE] = sum;
		}
		return block;
	}

	async function waitForByte(timeout = 10000): Promise<number> {
		const timer = new Promise<number>((_, reject) => setTimeout(() => reject(new Error('Timeout waiting for receiver')), timeout));
		const read = reader.read().then(({ value }) => (value && value.length > 0) ? value[0] : -1);
		return Promise.race([read, timer]);
	}

	// Flush any bytes in the buffer before handshake
	let flushTries = 5;
	while (flushTries-- > 0) {
		const { value } = await reader.read();
		if (!value || value.length === 0) break;
		console.log('Flushed byte before handshake:', value[0]);
	}

	// Wait for initial NAK or 'C' (CRC)
	let retries = 0;
	while (retries < MAX_RETRIES) {
		console.log("Waiting for handshake byte... on attempt #", retries + 1);
		try {
			const byte = await waitForByte(10000);
			console.log('Handshake byte:', byte);
			if (byte === NAK) { useCRC = false; break; }
			if (byte === CRC) { useCRC = true; break; }
			if (byte === CAN) {
				writer.releaseLock();
				reader.releaseLock();
				await resumeListening();
				throw new Error('Transfer cancelled by receiver');
			}
		} catch (e) {
			retries++;
			if (retries >= MAX_RETRIES) {
				writer.releaseLock();
				reader.releaseLock();
				await resumeListening();
				throw new Error('No response from receiver');
			}
		}
	}
	console.log('XMODEM handshake: useCRC =', useCRC);

	// Send blocks
	while (offset < data.length && !aborted) {
		const chunk = data.slice(offset, offset + BLOCK_SIZE);
		const block = buildBlock(blockNum, chunk, useCRC);
		let sent = false;
		retries = 0;
		while (!sent && retries < MAX_RETRIES) {
			await writer.write(block);
			try {
				const resp = await waitForByte(10000);
				if (resp === ACK) {
					sent = true;
				} else if (resp === NAK) {
					retries++;
				} else if (resp === CAN) {
					aborted = true;
					throw new Error('Transfer cancelled by receiver');
				} else {
					retries++;
				}
			} catch (e) {
				retries++;
				if (retries >= MAX_RETRIES) {
					writer.releaseLock();
					reader.releaseLock();
					await resumeListening();
					throw new Error('No ACK/NAK from receiver');
				}
			}
		}
		if (!sent) {
			writer.releaseLock();
			reader.releaseLock();
			await resumeListening();
			throw new Error(`Block ${blockNum} failed after ${MAX_RETRIES} retries`);
		}
		offset += BLOCK_SIZE;
		blockNum = (blockNum + 1) & 0xFF;
		if (onProgress) onProgress(Math.floor((offset / data.length) * 100));
	}

	// Send EOT
	retries = 0;
	let eotAcked = false;
	while (!eotAcked && retries < MAX_RETRIES) {
		await writer.write(new Uint8Array([EOT]));
		try {
			const resp = await waitForByte(10000);
			if (resp === ACK) {
				eotAcked = true;
			} else if (resp === CAN) {
				throw new Error('Transfer cancelled by receiver');
			} else {
				retries++;
			}
		} catch (e) {
			writer.releaseLock();
			reader.releaseLock();
			await resumeListening();
			retries++;
			if (retries >= MAX_RETRIES) throw new Error('No ACK for EOT');
		}
	}
	if (onProgress) onProgress(100);
	writer.releaseLock();
	reader.releaseLock();
	await resumeListening();
}

